import * as React from 'react';

var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLocationOutline16 = function SvgLocationOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.914 8.159-.002.003-.004.008a960.2 960.2 0 0 1-4.897 6.973 942.47 942.47 0 0 1-2.503-3.5 294.07 294.07 0 0 1-1.622-2.3 66.56 66.56 0 0 1-.56-.814 14.794 14.794 0 0 1-.241-.37.32.32 0 0 1-.005-.01c-1.055-2.033-.646-4.481 1.027-6.096 2.145-2.071 5.64-2.07 7.785 0 1.678 1.62 2.084 4.072 1.022 6.106z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 2,
    stroke: "currentColor"
  })));
};

var LocationOutline16Svg = SvgLocationOutline16;

export { LocationOutline16Svg as default };
//# sourceMappingURL=LocationOutline16.svg.js.map
